import { Separator } from '@/shared/ui/separator'

import { type FC } from 'react'

/**
 * SideMenu.Separator — horizontal divider between groups of items.
 */
export const SideMenuSeparator: FC = () => (
  <div className="side-menu-separator">
    <Separator orientation="horizontal" />
  </div>
)

SideMenuSeparator.displayName = 'SideMenuSeparator'
